/*Clase TimeChrono, contiene los datos para registro de tiempo restante en la prueba */
  export class TimeChrono{

    //constructor de la clase
    constructor(

      //id de la credencial
      public credencial:number,

      //indica el tiempo actual del cronometro
      public timeChrono:any,

      //Indica la fecha de creacion del registro
      public fechaChrono:Date,

      //Indica la sesion actual
      public sesion: number
    ){}
}
